import storageService from '@src/services/storage-service';
import { atomWithImmer } from 'jotai-immer';
import { jotaiStore } from '../store';
// Create the atom with initial state from localStorage
export const themeAtom = atomWithImmer({
    isDarkModeOn: storageService.localStorage.get('isDarkModeOn') === 'true',
});
themeAtom.debugLabel = 'themeAtom';

export function setDarkMode(isDarkModeOn: boolean) {
    if (!document.startViewTransition) return switchTheme(isDarkModeOn);
    document.startViewTransition(() => switchTheme(isDarkModeOn));
}

export function switchTheme(isDarkModeOn: boolean) {
    if (!isDarkModeOn) {
        document.documentElement.classList.remove('dark');
        storageService.localStorage.remove('isDarkModeOn');
    } else {
        document.documentElement.classList.add('dark');
        storageService.localStorage.set('isDarkModeOn', 'true');
    }

    // Update the atom state using Immer
    jotaiStore.set(themeAtom, draft => {
        draft.isDarkModeOn = isDarkModeOn;
    });
}

export function isDarkModeOn() {
    return jotaiStore.get(themeAtom).isDarkModeOn;
}
